import { AccountRecord } from "@services/http/responses/AccountResponse";
import { ROOT_CLEAR_ALL, RootDispatch } from "@store";
import { clearMe, setMe } from "@store/me/actions";
import { cleanMinersTableState } from "@store/minersTable/actions";
import { clearMinerTypes, getAllTypes } from "@store/minerTypes/actions";
import { clearMiningPlans, setMiningPlans } from "@store/miningPlans/actions";
import { clearMiners } from "@store/storedMiners/actions";
import { clearUsers } from "@store/users/actions";
import dbg from "@utils/dbg";
import { batch } from "react-redux";
import {
  ActionBaseAuth,
  ActionTypesAuthE,
  ActionUpdateAuth,
  IAuthorization,
} from "./actionTypes";
import AUTHSTATES from "./AuthStates";
import { clearAuth, setAuthData } from "./cookieStorage";

export function updateAuth(data: IAuthorization): ActionUpdateAuth {
  return {
    type: ActionTypesAuthE.UPDATE_AUTH,
    payload: { ...data },
  };
}

export function logon(data: AccountRecord) {
  return async (dispatch: RootDispatch) => {
    if (process.env.NODE_ENV === 'development') {
      setAuthData({
        Token: data.Token,
        TokenExpiresAt: data.TokenExpiresAt,
        TokenLifeTime: data.TokenLifeTime,
      });
    }
    batch(() => {
      dispatch(
        updateAuth({
          id: data.account.Id,
          state: AUTHSTATES.AUTHORIZED,
          isAdmin: data.account.is_admin ? data.account.is_admin : false,
          email: {
            isPrivate: data.account.email.is_private,
            value: data.account.email.value,
          },
          role: data.account.role,
          uuid: data.account.uuid,
          name: data.account.name || "",
          controllerId: data.account.controller_id,
          m_online: data.account.m_online,
          m_low: data.account.m_low,
          m_offline: data.account.m_offline,
        })
      );
      dispatch(setMe(data.account));
      dispatch(setMiningPlans(data.plans || []));
      dispatch(getAllTypes(data.types || []));
    });
  };
}

export function logout(tag: string) {
  return async (dispatch: RootDispatch) => {
    // if (handle) await logoff();
    //dbg.trace("LOGOUT");
    try {
      dbg.log(`LOGOUT ${tag}`);
      clearAuth();
      batch(() => {
        dispatch(authLogout());
        dispatch(clearMe());
        dispatch(clearUsers());
        dispatch(clearMiners());
        dispatch(clearMiningPlans());
        dispatch(clearMinerTypes());
        dispatch(cleanMinersTableState());
        dispatch({ type: ROOT_CLEAR_ALL });
      });
    } finally { // очистка стораджа должна произойти при любых условиях, вопрос безопасности
      //console.log("LOGOUT finally");
      localStorage.clear();
      document.cookie.split(';').forEach(cookie => { // надежно очищаем все возможные куки
        const eqPos = cookie.indexOf('=');
        const name = eqPos > -1 ? cookie.substring(0, eqPos) : cookie;
        document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT';
      });
      //dbg.log("STORAGE CLEARED");
    }
  };
}

export function authLogout(): ActionBaseAuth {
  return {
    type: ActionTypesAuthE.LOGOUT,
  };
}

// вызывается только из initStore
export function init(): ActionBaseAuth {
  return {
    type: ActionTypesAuthE.INIT,
  };
}
